import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import {
  useCurrentParticipant,
  useMe,
  useParticipantUnreadMessages,
} from '@app/api';
import { CenteredLoader, PageTitle } from '@app/core';
import { Navigate } from 'react-router-dom';
import { NewMessageNotification } from './components/NewMessageNotification';
import { EmptyState } from '../Studies/components/EmptyState';
import InboxInk from '@app/illu/Small/InboxInk.svg';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  page: {
    minHeight: '100%',
    maxWidth: theme.maxContentWidth.hugeBlock,
    padding: theme.marginBase * 5,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.media.mobile]: {
      padding: [theme.marginBase * 5, theme.marginBase * 2],
      display: 'block',
    },
  },
  title: {
    ...theme.fonts.h2,
    marginBottom: theme.marginBase * 4,
  },
  listNotificationContainer: {
    ...theme.flexCenter,
    justifyContent: 'flex-start',
    flexDirection: 'column',
    gap: theme.marginBase * 2,
  },
}));

export const Notifications = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { data: me, isLoading } = useMe();
  const { data: participant, isLoading: isParticipantLoading } =
    useCurrentParticipant();
  const { data: notificationsMessages } = useParticipantUnreadMessages(
    participant?.id,
  );

  if (isLoading || isParticipantLoading) {
    return <CenteredLoader />;
  }
  if (!me || !participant) {
    return <Navigate to={'/login'} />;
  }

  return (
    <div className={classes.page}>
      <div>
        <PageTitle title={'notifications'} />
        <h1 className={classes.title}>Notifications</h1>
        <div className={classes.listNotificationContainer}>
          {notificationsMessages && notificationsMessages.length !== 0 ? (
            notificationsMessages.map((message) => (
              <NewMessageNotification
                message={message.content}
                participationId={message.participationId}
              />
            ))
          ) : (
            <EmptyState
              illustration={InboxInk}
              alt="Inbox"
              title={t('notification.empty.title')}
              description={t('notification.empty.description')}
            />
          )}
        </div>
      </div>
    </div>
  );
};
